import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { Button, Card, Col, Container, Row, Alert } from "react-bootstrap";
import DatePicker from "react-datepicker";
import 'react-datepicker/dist/react-datepicker.css';
import { addMonths } from 'date-fns';
import { AiOutlineClockCircle } from "react-icons/ai";
import { BsCameraVideo } from "react-icons/bs";
import dayjs from 'dayjs';
import { getSlotStart, selectDateTimeStart } from "../Store/Slices/slotSlice";
import Loader from "../Components/Loader";

const ScheduleMeeting = () => {
    const dispatch = useDispatch();
    const slot = useSelector((state) => state?.slot);
    const [searchParams] = useSearchParams();
    const [availableSlots, setAvailableSlots] = useState([]);
    const [selectedDate, setSelectedDate] = useState(new Date());
    const [showToast, setShowToast] = useState(false);
    const [toastMessage, setToastMessage] = useState("");

    const queryParams = {};
    for (let [key, value] of searchParams.entries()) {
        queryParams[key] = value;
    }

    useEffect(() => {
        const onlyDate = dayjs(new Date()).format("YYYY-MM-DD");
        selectDateHandler(onlyDate);
    }, []);

    const selectDateHandler = (date) => {
        const obj = {
            email: queryParams.hostEmail,
            date: date,
        };
        dispatch(getSlotStart(obj));
    };

    const selectTimeHandler = (date_time, time) => {
        const obj = {
            hostEmail: queryParams.hostEmail,
            email: queryParams.email,
            date: date_time,
            type: queryParams.type,
            duration: 30,
            timeZone: slot.timeZone,
            time: time
        };
        dispatch(selectDateTimeStart(obj));
    };

    useEffect(() => {
        if (slot?.message && slot?.successStatus) {
            console.log("-------slot",slot);
            
            setAvailableSlots(slot?.slot || []);
            if (slot?.message == "Meeting Scheduled Successfully" || slot?.message == "Meeting Rescheduled Successfully") {
                setToastMessage(slot?.message);
                setShowToast(true);
                setTimeout(() => {
                    setShowToast(false);
                    window.close();

                }, 3000);
            }
        }
    }, [slot]);

    //only show enable days for calender
    const enabledDays = slot.shiftDays || ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];

    // Filter function to enable only specified days
    const isDateEnabled = (date) => {
        const dayName = dayjs(date).format('dddd');
        return enabledDays?.includes(dayName);
    };

    return (
        <>
            {showToast && (
                <div style={{
                    position: "fixed",
                    top: 20,
                    right: 20,
                    zIndex: 9999,
                    minWidth: 250
                }}>
                    <Alert variant="success">
                        {toastMessage}
                    </Alert>
                </div>
            )}
            
            
            <Loader isVisible={slot?.isLoading} />

            <Container>
                <Card className="shadow-sm p-0" style={{ maxHeight: 'calc(100vh - 40px)' }}>
                    <Row>
                        <Col xl="4" className="border-end">
                            <div className="h-100 p-3 p-xl-4">
                                <h6 className="text-secondary fw-semibold">Digylax Sales Team</h6>
                                <h4 className="fw-semibold">AI Generated meeting</h4>
                                <div className="vstack gap-3 text-secondary my-3">
                                    <div className="hstack gap-2">
                                        <AiOutlineClockCircle size={20} />
                                        <span className="fw-medium">30 min</span>
                                    </div>
                                    <div className="hstack gap-2">
                                        <BsCameraVideo size={20} />
                                        <span className="fw-medium">Web conferencing details provided upon confirmation.</span>
                                    </div>
                                </div>
                                <p className="fs-15">Digylax Private Limited</p>
                            </div>
                        </Col>
                        <Col xl="8">
                            <div className="h-100 p-3 p-xl-4">
                                <div className="fs-5 fw-semibold mb-3">Select a Date & Time</div>
                                <Row className="align-items-start justify-content-center g-0">
                                    <Col xl="7">
                                        <div className="h-100">
                                            <DatePicker
                                                calendarClassName="schedule-meeting-calendar"
                                                calendarIconClassName="nav-icon"
                                                onChange={(date) => {
                                                    const onlyDate = dayjs(date).format('YYYY-MM-DD');
                                                    setSelectedDate(date);
                                                    selectDateHandler(onlyDate);
                                                }}
                                                minDate={new Date()}
                                                maxDate={addMonths(new Date(), 1)}
                                                inline
                                                showDisabledMonthNavigation
                                                filterDate={isDateEnabled}
                                            />
                                        </div>
                                    </Col>
                                    <Col xl="5" className="px-3">
                                        <div className="h-100">
                                            <div className="lh-lg pb-3 mb-2">
                                                {dayjs(selectedDate).format("dddd, MMMM D")}
                                            </div>
                                            <div className="vstack gap-2 pe-3 overflow-y-auto" style={{ maxHeight: 'calc(100vh - 24vh)' }}>
                                                {availableSlots.length > 0 ? (
                                                    availableSlots.map(({ time, status, date }, index) => (
                                                        <Button
                                                            key={index}
                                                            variant={status === 'free' ? "outline-primary" : "secondary"}
                                                            className="w-100 py-3 fw-semibold"
                                                            size="lg"
                                                            onClick={() => selectTimeHandler(date, time)}
                                                            disabled={status !== 'free'}
                                                        >
                                                            {time}
                                                        </Button>
                                                    ))
                                                ) : (
                                                    <div className="bg-light rounded p-4 text-center w-100" style={{ fontSize: "16px" }}>
                                                        <div className="fw-bold mb-1">No times available {dayjs().format("MMMM DD")}</div>
                                                        <div>Please select another date</div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        </Col>
                    </Row>
                </Card>
            </Container>
        </>
    );
};

export default ScheduleMeeting;

 